import { HttpClient } from '@adapters/HttpClient';

export interface CourierOption {
  id: string;
  name: string;
}

/**
 * CouriersApiAdapter - Adapter para obtener couriers para filtros
 * 
 * Proporciona métodos para cargar la lista de couriers disponibles
 * para usar en filtros de ViewPreInvoices
 */
export class CouriersApiAdapter {
  constructor(private httpClient: HttpClient) {}

  /**
   * Obtiene todos los couriers disponibles
   * @returns Promise con array de couriers
   */
  async getAll(): Promise<CourierOption[]> {
    try {
      const response = await this.httpClient.get<any[]>('/couriers');
      
      return response.map((courier) => ({
        id: String(courier.id),
        name: courier.name,
      }));
    } catch (error) {
      console.error('Error loading couriers:', error);
      return [];
    }
  }
}

